import { INotification } from 'store/notifications/types';
import { CHAT } from 'router/routes';

export interface ITechnicianConfirmationRequest {
  techName: string;
}

export interface INewAdminMessage {
  chatId: number;
  dateTime: string;
  message: string;
  type: number;
  userName: string;
  metadata: string | null;
  ticketNumber: string | null;
}

export interface IVerificationRequest {
  code: string;
  phoneNumber: string;
  durationMin: number;
  date: Date;
  crmId: number;
}

export const createNotificationFromAdminMessage = (message: INewAdminMessage): INotification => ({
  link: CHAT.replace(':chatId', `${message.chatId}`),
  text: `New Message for ${message.ticketNumber}`,
  id: new Date().getTime(),
  chatId: +message.chatId,
});
